import { render, staticRenderFns } from "./select-tree.vue?vue&type=template&id=d45b890e&scoped=true&"
import script from "./select-tree.vue?vue&type=script&lang=js&"
export * from "./select-tree.vue?vue&type=script&lang=js&"
import style0 from "./select-tree.vue?vue&type=style&index=0&id=d45b890e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45b890e",
  null
  
)

export default component.exports